export const PAGE_LIMIT = 20;

export const PATHS = {
  EDIT: "edit",
  HISTORY: "history",
  SUMMARY: "summary",
};

export const TEXTS = {
  AUTOMATIC: "Automatic",
  DEFAULT_RELEASE_STAGE: "Release stage",
  EXPORT_BUTTON_LABEL: "Export to CSV",
  EXPORT_ERROR_MODAL_CLOSE_BUTTON_LABEL: "Close",
  EXPORT_ERROR_MODAL_TITLE: "Error",
  EXPORT_GENERIC_ERROR: "Failed to export the publications to CSV.",
  FILTERS: "Publications filters",
  FILTERS_HISTORY: "Publications history filters",
  FORM_RESET_BUTTON: "Reset",
  FORM_SUBMIT_BUTTON: "Update publication",
  HEADER: {
    EDIT: "Edit publications",
    HISTORY: "Publications history",
    SUMMARY: "Publications summary",
  },
  LEGEND: {
    GUIDE:
      "The three symbols in the OEM or client type row/column represent the variant publication status on that OEM or client type for RS1, RS2 and RS3 respectively. The symbols have the following meaning:",
    STATUS_NOT_PUBLISHED_NOT_PROMOTED:
      "The variant is not promoted and not published on the release stage. It must be promoted before publication.",
    STATUS_NOT_PUBLISHED_PROMOTED:
      "The variant is promoted but not published on the release stage. It can be published.",
    STATUS_PROMOTED_BUT_CANNOT_BE_PUBLISHED:
      "The variant is promoted but this target is not included for that stage, so it cannot be published.",
    STATUS_PUBLISHED_PROMOTED: "The variant is published on the release stage.",
    STATUS_RS_NOT_AVAILABLE_ON_OEM:
      "The variant cannot be promoted, because OEM settings don't allow it",
    TITLE: "Legend",
  },
  NO_PUBLICATION_HISTORY: "There is no publication history to display.",
  NO_PUBLICATIONS: "There are no publications to display.",
  PROVIDER_COL: "Provider",
  PUBLICATION_HISTORY_LIMITED:
    "There are #{count} more changes within this time frame. Use the publications history filters to narrow the results.",
  SELECT_CLIENT_TYPES_BUTTON: "Select OEMs & client types.",
  SELECT_OEMS_BUTTON: "Select OEMs.",
  SUBMIT_SUCCESS_MESSAGE: "The values have been saved.",
  TAB_LABEL: {
    EDIT: "Edit",
    HISTORY: "History",
    SUMMARY: "Summary",
  },
  VALIDATION_ERROR:
    "In the form, some values are missing or invalid. Please correct them and try again.",
  VARIANT_COL: "Variant",
};
